import { BrandsSettings } from '../types/brands-settings';

/**
 * Feature flags de Brands (Social / Avatars) — POR MARCA, via **client settings**.
 *
 * Fuente de verdad: los `brandsSettings` de la marca (settings service del backend, mismo
 * mecanismo que `disableBannerCreation`; se leen con useSettingsContext y viven en DynamoDB
 * por marca → editables sin redeploy). Flags:
 *   - `enableSocial`  → pestaña "Social" (social-admin) visible
 *   - `enableAvatars` → módulo "Digital Brand Ambassador" (Avatars) visible
 *
 * Semántica OPT-IN estricta: por defecto NO se ve nada gateable. Solo se muestra lo que la
 * marca tenga habilitado explícitamente. "Asset multiplier" es el módulo base y siempre está.
 */

const AVATARS_MODULE_ID = 'digital-brand-ambassador';

export interface BrandAccess {
  showSocial: boolean;
  showAvatars: boolean;
  /** IDs de PLATFORM_MODULES habilitados (para el selector de módulos del header). */
  allowedModuleIds: string[];
}

export const getBrandAccess = (settings?: BrandsSettings): BrandAccess => {
  const showAvatars = !!settings?.enableAvatars;
  return {
    showSocial: !!settings?.enableSocial,
    showAvatars,
    // 'asset-multiplier' es el módulo base (siempre); Avatars solo si la marca lo habilitó.
    allowedModuleIds: ['asset-multiplier', ...(showAvatars ? [AVATARS_MODULE_ID] : [])],
  };
};
